import { AppCard } from "../../../../components/common/card";
import { Text } from "../../../../components/common/typography";

interface ProductRequestStatusMessagesProps {
  rejectionReason?: string | null;
  odooProductId?: number | null;
}

export function ProductRequestStatusMessages({
  rejectionReason,
  odooProductId,
}: ProductRequestStatusMessagesProps) {
  return (
    <>
      {rejectionReason && (
        <AppCard
          title="Rejection Reason"
          color="bg-bgDefault"
          className="w-full border-l-4 border-red-500"
        >
          <Text variant="body" className="text-accentError">
            {rejectionReason}
          </Text>
        </AppCard>
      )}

      {odooProductId && (
        <AppCard
          title="Product Created"
          color="bg-bgDefault"
          className="w-full border-l-4 border-green-500"
        >
          <Text variant="body">
            Odoo Product ID: {String(odooProductId)}
          </Text>
        </AppCard>
      )}
    </>
  );
}
